import React, { useState } from 'react';

import { MainCheckBox } from 'components/Checkbox';
import CheckedIcon from 'icons/contact-us/checked.svg';
import UncheckedIcon from 'icons/contact-us/unchecked.svg';

interface Props {
  file: File;
  onChange: (fileName: string) => void;
  disabled?: boolean;
}

const bytesToSize = (bytes: number, decimals = 2) => {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const bytesAmount = 1024;
  const decimalsAmount = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const sizeItem = Math.floor(Math.log(bytes) / Math.log(bytesAmount));
  const size = parseFloat((bytes / bytesAmount ** sizeItem).toFixed(decimalsAmount));

  return `${size} ${sizes[sizeItem]}`;
};

const FileItem = ({ file, onChange, disabled }: Props) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleChange = () => {
    setIsChecked(!isChecked);
    onChange(file.name);
  };

  const checkedClassName = isChecked ? 'checked' : '';

  return (
    <div className="file">
      <MainCheckBox
        className="file-checkbox"
        id={file.name}
        onChange={handleChange}
        checked={isChecked}
        classes={{ checked: 'checked' }}
        checkedIcon={<CheckedIcon />}
        icon={<UncheckedIcon />}
        disabled={disabled}
      />
      <label className={`name body-3 ${checkedClassName}`} htmlFor={file.name}>
        {file.name}
      </label>
      <p className="file-size">{bytesToSize(file.size)}</p>
    </div>
  );
};

export default FileItem;
